module.exports = __webpack_public_path__ + "static/gleen-logo-f5a7c9a7feee3cca3dde607d80856261.png";